var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13654 7.94942C7.13654 7.80542 7.19167 7.66142 7.30135 7.55173L10.2787 4.57439L7.30135 1.59705C7.08142 1.37712 7.08142 1.02161 7.30135 0.801673C7.52129 0.581734 7.8768 0.581734 8.09674 0.801673L11.4718 4.1767C11.6917 4.39664 11.6917 4.75214 11.4718 4.97208L8.09674 8.34711C7.8768 8.56705 7.52129 8.56705 7.30135 8.34711C7.19167 8.23742 7.13654 8.09342 7.13654 7.94942Z",
    fill: "#BAC0CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.363115 14.7695C0.363115 14.6216 0.421616 14.4798 0.525117 14.3746L3.92377 10.9293C4.14202 10.7077 4.49809 10.706 4.71915 10.9237C4.94078 11.1419 4.94247 11.4985 4.72478 11.719L1.72381 14.7611L4.71634 17.6709C4.93853 17.888 4.94415 18.2435 4.72759 18.4663C4.51102 18.689 4.15496 18.6935 3.93221 18.4775L0.533554 15.1728C0.426678 15.0682 0.364803 14.9259 0.363115 14.7757C0.363115 14.7734 0.363115 14.7718 0.363115 14.7695Z",
    fill: "#BAC0CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.386625 9.63677L0.386625 5.42023C0.386625 4.64341 1.01832 4.01172 1.79514 4.01172L11.0742 4.01172C11.3847 4.01172 11.6367 4.26372 11.6367 4.57422C11.6367 4.88473 11.3847 5.13673 11.0742 5.13673L1.79514 5.13673C1.63876 5.13673 1.51163 5.26385 1.51163 5.42023L1.51163 9.63677C1.51163 9.94727 1.2602 10.1993 0.94913 10.1993C0.638065 10.1993 0.386625 9.94727 0.386625 9.63677Z",
    fill: "#BAC0CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.386625 14.6993C0.386625 14.3882 0.638065 14.1368 0.94913 14.1368L10.2282 14.1368C10.3846 14.1368 10.5117 14.0096 10.5117 13.8533L10.5117 9.63672C10.5117 9.32622 10.7637 9.07422 11.0742 9.07422C11.3847 9.07422 11.6367 9.32622 11.6367 9.63672L11.6367 13.8533C11.6367 14.6301 11.005 15.2618 10.2282 15.2618L0.94913 15.2618C0.638065 15.2618 0.386625 15.0103 0.386625 14.6993Z",
    fill: "#BAC0CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.585f47430e8004022ede39e343e6e84f.svg";
export { ForwardRef as ReactComponent };